import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2f2bbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "split-header d-flex flex-row justify-content-center align-items-center" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = {
  class: "dropdown-toggle",
  href: "#",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = {
  class: "dropdown-menu dropdown-menu-dark",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_5 = ["onClick"]

import { ViewIndex } from "@/classes/data-structures/view-index";
import { Utils } from "@/classes/utils/utils";
import { useAppStateStore } from "@/store/app-state";
import { Survey } from "@/swagger";
import { computed } from "vue";

interface SplitHeaderProps {
	view: ViewIndex;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitHeader',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
	view: ViewIndex;
};

const appState = useAppStateStore()



let selectedSurvey = computed(() => {
	return props.view == ViewIndex.View1 ? appState.view1Survey : appState.view2Survey;
});

let selectableProjects = computed(() => {
	if (!appState.project) {
		return [];
	}
	return appState.project.surveys;
});

function changeSurvey(survey: Survey) {
	if (props.view == ViewIndex.View1) {
		appState.setView1Survey(survey);
	} else {
		appState.setView2Survey(survey);
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, _toDisplayString(_unref(Utils).formatSurveyName(_unref(selectedSurvey)) || "Select a survey"), 1),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectableProjects), (survey) => {
            return (_openBlock(), _createElementBlock("li", {
              key: survey.uuid
            }, [
              _createElementVNode("button", {
                class: "dropdown-item",
                type: "button",
                onClick: ($event: any) => (changeSurvey(survey))
              }, _toDisplayString(_unref(Utils).formatSurveyName(survey)), 9, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})